/* eslint-disable camelcase */
import * as z from 'zod'

const emailSchema = z.union([
  z.string()
    .email('Must be a valid email')
    .optional(),
])

export const schema = z.object({
  status: z
    .string()
    .optional(),
  vehicleType: z
    .string()
    .optional(),
  pickupAddress: z
    .string({ required_error: 'This field is required' })
    .min(1, { message: 'Please enter a pickup address' }),
  contactEmailAddress: emailSchema,
  contactMobileNumber: z
    .string()
    .refine(value => /^\d{9,11}$/.test(value), {
      message: 'Invalid mobile number',
    })
    .optional(),
  comments: z
    .string()
    .optional(),
})
